<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="3" lg="2">
      <FilterSearch :fetchData="fetchPayments" />
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="2">
      <CitySelectFilter :fetch-data="fetchPayments" />
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="2">
      <FilterAutocomplete
        :label="$t('payment.filter.orderBy')"
        :fetchData="fetchPayments"
        :items="orderBy"
        type="orderBy"
      />
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="2">
      <FilterAutocomplete
        :label="$t('payment.filter.transferMethods')"
        :fetchData="fetchPayments"
        :items="transferMethods"
        type="transferMethod"
      />
    </v-col>
  </v-row>
</template>

<script>
import CitySelectFilter from '@/components/city/CitySelectFilter'
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'
import { mapGetters, mapActions } from 'vuex'
import FilterSearch from '@/components/filters/FilterSearch'
export default {
  name: 'PaymentListFilter',
  data() {
    return {
      transferMethods: [
        { value: 'ASAAS_TRANSFER', name: this.$t('payment.transferMethods.ASAAS_TRANSFER') },
        { value: 'BANK_TRANSFER', name: this.$t('payment.transferMethods.BANK_TRANSFER') },
      ],
      orderBy: [
        { value: 'ASC', name: this.$t('payment.orderBy.ASC') },
        { value: 'DESC', name: this.$t('payment.orderBy.DESC') },
      ]
    }
  },
  components: { 
    FilterSearch,
    CitySelectFilter,
    FilterAutocomplete
  },

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    ...mapActions(['fetchPayments']),
  },
}
</script>